define('shoptheme/components/cartware/checkout',[
	"cartware/components/_base",
	"jquery",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	Component,
	$,
	BEM,
	BreakPoints,
	enquire,
	PopupHtml
) {

	var _popupTemplate = null;

	return Component.create({
		init: function() {
			var self = this;
			var blocks = $('.' + BEM.buildBlockClassname('payment-tooltip'));
			var schippingCompany = $('#shipping\\:company');
			var countryTooltip = $('.b_opcheckout-progress-information');

			if (schippingCompany.length > 0 && countryTooltip.length > 0) {
				schippingCompany.after($('.b_opcheckout-progress-information'));
				schippingCompany.attr('autocomplete', 'nope');
				
				schippingCompany.on('focus', function () {
					countryTooltip.show();
				});

				schippingCompany.on('blur', function () {
					countryTooltip.hide();
				});

			}

			$.each(blocks, function(){
				var block = BEM.block(this),
					link = block.getElements('link'),
					content = block.getElements('tooltip-inner');

				link.on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					var title = '';
					var message = content.html();
					self._showMessage(title, message);

				});
			});
		},
		_renderPopup: function(data) {
			if (null === _popupTemplate) {
				_popupTemplate = _.template(PopupHtml);
			}
			return _popupTemplate(data);
		},
		_showMessage: function(title, message) {
			$.magnificPopup.open({
				items: {
					src: this._renderPopup({
						title: title,
						body: message
					}),
					type: 'inline'
				}
			});
		}
	});
});
